export default function Spinner({ label }: { label?: string }) {
    return (
        <div className="loading">
            <div className="spinner" />
            {label ? <div>{label}</div> : null}
        </div>
    );
}
